// Replaces React Router's default peach/orange error screen when a route throws.
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button } from 'antd';

export default function RouteErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    let title = 'Something went wrong';
    let message = 'An unexpected error occurred while loading this page.';

    if (isRouteErrorResponse(error)) {
        title = error.status === 404 ? 'Not found' : `Error ${error.status}`;
        message = error.statusText || message;
    } else if (error instanceof Error) {
        message = error.message;
    } else if (typeof error === 'string') {
        message = error;
    }

    const stack = error instanceof Error ? error.stack : null;

    return (
        <div
            style={{
                minHeight: '100vh',
                padding: 24,
                boxSizing: 'border-box',
                background: '#fbfbfc',
                color: '#1d1c1d',
                fontFamily: 'system-ui, -apple-system, Segoe UI, sans-serif',
            }}
        >
            <div style={{ maxWidth: 720, margin: '0 auto' }}>
                <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 8px' }}>{title}</h1>
                <p style={{ margin: '0 0 20px', color: 'rgba(0,0,0,0.65)', lineHeight: 1.5 }}>{message}</p>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
                    <Button type="primary" onClick={() => window.location.reload()}>
                        Reload page
                    </Button>
                    <Button onClick={() => navigate(-1)}>Go back</Button>
                </div>
                {import.meta.env.DEV && stack ? (
                    <pre
                        style={{
                            margin: 0,
                            padding: '12px 14px',
                            borderRadius: 4,
                            border: '1px solid rgba(0,0,0,0.08)',
                            background: '#f4f4f4',
                            color: '#1d1c1d',
                            fontSize: 12,
                            lineHeight: 1.45,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            overflow: 'auto',
                            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                        }}
                    >
                        {stack}
                    </pre>
                ) : null}
            </div>
        </div>
    );
}
